import axios from 'api/axios'
import { Payment } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

export interface UpdatePaymentDetailsBody {
	url: string
}

/**
 * API call for Update PDF url
 * @param body UpdatePaymentDetailsBody - data to be send to backend for Update PDF url
 * @returns PaymentResponse - Response object returned from the server
 */

export const updatePaymentDetails = async (
	id: string,
	body: UpdatePaymentDetailsBody
) => {
	try {
		const { data } = await axios.patch<Payment>(
			`client/payment-url/update/${id}`,
			body
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default updatePaymentDetails
